const disp = [
    {
        label: '全部',
        value: 0,
    },
    {
        label: '最新上会',
        value: 1,
    },
    {
        label: '上会已通过',
        value: 2,
    },
    {
        label: '上会未通过',
        value: 3,
    },
    {
        label: '未上会',
        value: 4,
    },
];

export default disp;
